import {
  Component,
  ElementRef,
  forwardRef,
  OnInit,
  Renderer2,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  SelectControlValueAccessor,
} from '@angular/forms';
import { Subscription } from 'rxjs';

import { IApplication } from '../../interfaces/account/account.interface';
import { CommonGraphqlService } from '../../services/common.graphql.service';

export const hasRequiredField = (abstractControl: AbstractControl): boolean => {
  if (abstractControl.validator) {
    const validator = abstractControl.validator({} as AbstractControl);
    if (validator?.required) {
      return true;
    }
  }

  const abstractControl2 = abstractControl as
    | ({
        controls: Record<string, AbstractControl>;
      } & AbstractControl)
    | undefined;

  if (abstractControl2) {
    for (const controlName in abstractControl2) {
      if (hasRequiredField(abstractControl2.controls[controlName])) {
        return true;
      }
    }
  }
  return false;
};

@Component({
  selector: '[formControlName] ddl-practice, [formControl] ddl-practice',
  templateUrl: './practice-management-dropdown.component.html',
  //styleUrls: ['./practice.management.dropdown.component.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => {
        return PracticeManagementDropdownComponent;
      }),
    },
  ],
})
export class PracticeManagementDropdownComponent
  extends SelectControlValueAccessor
  implements OnInit, ControlValueAccessor
{
  applications: IApplication[];
  subscriptions: Subscription = new Subscription();

  selectedValue: IApplication | string = '';
  override value = '';

  declare onChange: (_: string) => void;
  declare onTouched: () => void;

  disabled: boolean;
  isRequired = false;

  constructor(
    render: Renderer2,
    elementRef: ElementRef,
    private commonGraphqlService: CommonGraphqlService,
  ) {
    super(render, elementRef);
  }

  ngOnInit() {
    this.subscriptions.add(
      this.commonGraphqlService.getApplications().subscribe((applications) => {
        this.applications = applications;
      }),
    );
  }

  compareFn(c1?: IApplication, c2?: IApplication): boolean {
    return c1 && c2 ? c1.code === c2.code : c1 === c2;
  }

  override writeValue(value?: IApplication): void {
    if (value) {
      this.selectedValue = value;
    }
  }

  override registerOnChange(fn: (value: string) => string): void {
    this.onChange = fn;
  }

  override registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  override setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
